import styled from 'styled-components';

export const Wrapper = styled.article`
  padding: 1rem;
  .dark-comment {
    & > * {
      color: var(--light) !important;
    }
  }
  .light-comment {
    & > * {
      color: var(--dark) !important;
    }
  }
`;

export const Title = styled.h1`
  padding: 0;
  margin: 0;
  margin-bottom: 1rem;
  font-weight: normal;
  font-weight: bold;
  font-size: 2.25rem;
`;

export const DescriptionItem = styled.div`
  display: flex;
  align-items: center;
  svg {
    font-size: 1.2rem;
    margin-right: 0.4rem;
  }
`;

export const Description = styled.div`
  display: flex;
  font-size: 0.95rem;
  flex-direction: column;
  line-height: 1.6;
  margin-bottom: 1rem;
  ${DescriptionItem} {
    color: ${({ theme }) => theme?.disabled?.color};
  }
  @media screen and (min-width: 768px) {
    flex-direction: row;
    justify-content: flex-start;
    & > *:not(:first-child) {
      margin-left: 2rem;
    }
  }
`;

export const Beside = styled.div`
  & > * {
    margin: 3rem 0;
  }
`;
